/**
 * Conditional logging utility
 * Only logs in development mode or when DEBUG flag is enabled
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugEnabled = process.env.REACT_APP_DEBUG === 'true';

const shouldLog = isDevelopment || isDebugEnabled;

/**
 * Conditional console.log
 * @param  {...any} args - Arguments to log
 */
export const log = (...args) => {
  if (shouldLog) {
    console.log(...args);
  }
};

/**
 * Conditional console.warn
 * @param  {...any} args - Arguments to log
 */
export const warn = (...args) => {
  if (shouldLog) {
    console.warn(...args);
  }
};

/**
 * Conditional console.error
 * Always logs errors (even in production) but can be extended to send to error tracking service
 * @param  {...any} args - Arguments to log
 */
export const error = (...args) => {
  console.error(...args);

  // TODO: Send to error tracking service in production
  // if (!isDevelopment) {
  //   sendToErrorTrackingService(args);
  // }
};

/**
 * Conditional console.debug
 * @param  {...any} args - Arguments to log
 */
export const debug = (...args) => {
  if (shouldLog) {
    console.debug(...args);
  }
};

/**
 * Logger object with all methods
 */
const logger = {
  log,
  warn,
  error,
  debug,
  info: log, // Alias for log
};

export default logger;
